import { Button, Drawer, Form, Input, Row, Select } from 'antd'
import './DrawerSection.style.less'
import { DoubleRightOutlined, EditOutlined } from '@ant-design/icons'
import { startCase, camelCase } from 'lodash'
import { INSPECTION_SECTION_RESULT } from '@/constant/status'
import { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import { saveSectionRef } from '../../InSpectionReport.service'
import { queryClient } from '@/config/react-query'

interface Props {
  onClose: () => void
  open: boolean
  data: any
  index: number
}

function DrawerSection(props: Props) {
  const onFinish = () => {}

  const { RESULT_ARRAY, RESULT_OBJECT } = INSPECTION_SECTION_RESULT

  const [form] = Form.useForm()

  const result = Form.useWatch('result', form)
  const params = useParams()

  const [isChange, setisChange] = useState(false)
  const [mouseOver, setMouseOver] = useState(false)

  useEffect(() => {
    if (props.open) {
      form.setFieldsValue({
        ...(props.data?.result && { result: props.data?.result }),
        comment: props.data?.comment,
      })
    } else {
      form.resetFields()
    }
  }, [props.open])

  useEffect(() => {
    const isOpenSelect = document.querySelector('.ant-select-open')
    const allowScrolling = !mouseOver && !isOpenSelect
    if (allowScrolling) {
      document.body.style.overflow = 'auto'
    } else {
      document.body.style.overflow = ''
    }
  }, [mouseOver])

  const onSave = useMutation(async () => {
    await form.validateFields()
    const value = form.getFieldsValue()
    await saveSectionRef(
      params?.key,
      props.data?.id,
      value?.result ?? '',
      value?.comment
    )
    await queryClient.invalidateQueries(['GET_REPORT_DATA_HEADER'])
    await queryClient.invalidateQueries(['GET_REPORT_DATA'])
    props.onClose()
    setisChange(false)
  })

  useEffect(() => {
    if (!props.open) {
      setisChange(false)
    }
  }, [props.open])

  const color = (result) => {
    return result == RESULT_OBJECT.PASS
      ? '#65bf73'
      : result == RESULT_OBJECT.FAIL
      ? '#C03261'
      : result == RESULT_OBJECT.PENDING
      ? '#EF9747'
      : '#848484'
  }

  return (
    <Drawer
      title=""
      placement={'right'}
      closable={false}
      open={props.open}
      key={'right'}
      width={400}
      onMouseOver={() => {
        setMouseOver(true)
      }}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="drawer-container">
        <Button
          onClick={props.onClose}
          className="button-close"
          icon={<DoubleRightOutlined className="close-icon" />}
        />
        <Row align={'middle'} className="title-container">
          <EditOutlined /> <p>Edit Section</p>
        </Row>
        <p className="section-name">
          {props?.index}{' '}
          {startCase(
            camelCase(
              props.data?.name ?? `${props?.data?.color} ${props?.data?.size}`
            )
          )}
        </p>
        <Form
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          onChange={() => {
            setisChange(true)
          }}
          layout="vertical"
        >
          <Form.Item name={'result'} label="Result">
            <Select
              allowClear
              onChange={() => {
                setisChange(true)
              }}
              placeholder="Result"
              style={{
                color: color(result),
              }}
            >
              {RESULT_ARRAY.map((item) => {
                return (
                  <Select.Option
                    style={{
                      color: color(item),
                    }}
                    key={item}
                    value={item}
                  >
                    {item}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name={'comment'} label="Comment">
            <Input.TextArea autoSize size="large" placeholder="Comment" />
          </Form.Item>
        </Form>

        <Row className="button-container">
          <Button
            disabled={onSave.isLoading}
            onClick={props.onClose}
            className="cancel"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={() => onSave.mutateAsync()}
            size="large"
            type="primary"
            disabled={onSave.isLoading || !isChange}
            loading={onSave.isLoading}
          >
            Save
          </Button>
        </Row>
      </div>
    </Drawer>
  )
}

export default DrawerSection
